import React, { useRef, useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Input, Button, message, notification } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import logo from "../../../Assets/Images/Logo.svg";
import { encryptText } from "../../../Utlis/Encryption";
import updateUserStates from "../../../Utlis/UpdateUsersState";
import { login } from "../../../API/auth";
import { UserContext } from "../../../App";
import googleLogo from "../../../Assets/Icons/google.svg";
import githubLogo from "../../../Assets/Icons/github.svg";
import "./style.css";

const Login = () => {
  const { userData, setUserData, setUserToken } = useContext(UserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const cardRef = useRef(null);
  const buttonsRef = useRef(null);
  const [showScrollHint, setShowScrollHint] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const success = params.get("success");

    if (success === "true") {
      message.success("Payment successful 🎉");
    } else if (success === "false") {
      message.error("Payment cancelled ❌");
    }
  }, [location.search]);

  const checkVisibility = () => {
    if (cardRef.current && buttonsRef.current) {
      const cardRect = cardRef.current.getBoundingClientRect();
      const buttonsRect = buttonsRef.current.getBoundingClientRect();
      const isHidden = buttonsRect.bottom > cardRect.bottom;
      setShowScrollHint(isHidden);
    }
  };

  useEffect(() => {
    checkVisibility();
    window.addEventListener("resize", checkVisibility);

    const card = cardRef.current;
    const handleScroll = () => setShowScrollHint(false);
    if (card) card.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", checkVisibility);
      if (card) card.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    const { email, password } = values;

    try {
      const loginData = await login({ email, password });

      if (loginData?.status === 200) {
        const data = loginData?.data;

        localStorage.clear();
        localStorage.setItem(
          encryptText("token"),
          encryptText(
            JSON.stringify({ access: data.access, refresh: data.refresh })
          )
        );
        localStorage.setItem(
          encryptText("user"),
          encryptText(
            JSON.stringify({
              id: data.id,
              email: data.email,
              name: data.name,
              role: data.role,
              verified: data.verified,
              paid: data.paid,
            })
          )
        );

        updateUserStates(setUserData, setUserToken);

        const isVerified = data.verified === true || data.verified === "true";
        const isPaid = data.paid === true || data.paid === "true";

        if (!isVerified) {
          // Verified check first
          notification.warning({
            message: "Account not verified",
            description:
              "Please verify your email before accessing the dashboard.",
          });
          navigate("/email-unverified");
        } else if (!isPaid) {
          // Paid check next
          notification.warning({
            message: "Subscription Required",
            description: "Please subscribe to access the dashboard.",
          });
          navigate("/subscription");
        } else {
          // Verified and paid → dashboard
          message.success("Login successful!");
          navigate("/dashboard");
        }
      } else {
        notification.error({
          message: "Invalid login details",
          description: "Kindly provide correct email and password",
        });
      }
    } catch (error) {
      console.error("Login error:", error);
      notification.error({
        message: "Login failed",
        description: "Something went wrong. Please try again.",
      });
    }

    setLoading(false);
  };

  const handleCreateAccountClick = () => {
    navigate("/create-account");
  };

  return (
    <div className="login">
      <div className="login-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="login-card" ref={cardRef}>
          <div className="content-heading">Welcome back</div>
          <div className="sub-heading">Log in to your developer console</div>

          <Form
            name="login"
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Enter a valid email!" },
              ]}
            >
              <Input placeholder="Enter your email" prefix={<MailOutlined />} />
            </Form.Item>
            <div
              className="forget-password"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </div>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password!" },
              ]}
            >
              <Input.Password
                placeholder="Enter your password"
                prefix={<LockOutlined />}
              />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              className="submit-button"
              loading={loading}
            >
              Login
            </Button>
          </Form>

          {/* {showScrollHint && (
            <div className="scroll-hint">
              <span>Scroll for more ⬇️</span>
            </div>
          )} */}

          {/* <div className="or-separator">
            <div className="line"></div>
            <span>OR</span>
            <div className="line"></div>
          </div> */}

          {/* <div className="social-login-buttons" ref={buttonsRef}>
            <button className="social-btn google-btn">
              <img src={googleLogo} alt="Google" className="social-icon" />
              Login with Google
            </button>
            <button className="social-btn github-btn">
              <img src={githubLogo} alt="GitHub" className="social-icon" />
              Login with GitHub
            </button>
          </div> */}
        </div>

        <div className="bottom-info">
          Don’t have an account?
          <span className="auth-link" onClick={handleCreateAccountClick}>
            Create Account
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;
